// shelf-show-all — interaction primitive for the shelf family (book-row, wall-shelf).
//
// 🔴 ASK-139 F-139af — A SHELF'S SEATS DRAW THROUGH THE ONE RENDER PATH.
//
// The 2026-05-28 draft OWNED rendering: a procedural `BoxGeometry` per slot, cover-textured, sized
// from a hard-coded table. That is a second renderer beside `populateComics`, which already turns a
// line into its catalogue GLB (`hardcover-book.glb` — cover_front / cover_back / spine / pages_edge,
// bound from the registry's `surfaceSlots`) or the comic template, at world size, base on the seat
// (D-050 §1, D-074). Two renderers is how a book draws one way on a pedestal and another on a shelf.
//
// So this primitive only says what a shelf's seats ARE: picked up as a shelf, not browsed as a box.
// `populateComics` reads `populateInteraction: "shelf"` and wires each seat — a book into
// `stage.bookEntries` (the `book-row` interactable: hover outline, slide-out, ←/→, E → the book
// hero), anything else through the seated-item grain every holder surface already uses.

import { registerInteraction } from "./index.js";

function wireShelfShowAll({ composedEntry }) {
	if (composedEntry) composedEntry.populateInteraction = "shelf";
}

registerInteraction("shelf-show-all", wireShelfShowAll);
export { wireShelfShowAll };
